import {
  GET_WORKER,
  LIST_ATTENDANCE,
  LIST_WORKER,
  LIST_WORKER_LANGUAGE,
} from "../actions/types";

const initialState = {
  worker: null,
  workers: {
    count: 0,
    rows: [],
  },
  attendances: {
    count: 0,
    rows: [],
  },
  languages: [],
};

const workers = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKER:
      return {
        ...state,
        worker: action.payload,
        workers: initialState.workers,
      };
    case LIST_WORKER:
      return { ...state, workers: action.payload, worker: initialState.worker };
    case LIST_ATTENDANCE:
      return { ...state, attendances: action.payload };
    case LIST_WORKER_LANGUAGE:
      return { ...state, languages: action.payload };
    default:
      return { ...state };
  }
};

export default workers;
